module.exports = __webpack_public_path__ + "static/media/AstoriaSans-Light.f9a99f6d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AstoriaSans-Light.otf
// module id = 2962
// module chunks = 71